<!-- 销售产品记录 -->
<template>
  <div class="pagePadding home">
    <Form inline class="formMarginBtm20 clearfix">
      <!-- 客户名称 -->
      <FormItem>
        <span>客户名称：</span>
        <Select placeholder="请选择" v-model="queryFrom.customer_id" clearable filterable class="iviewIptWidth250" @on-change="customerChange" label-in-value>
          <Option v-for="(item, index) in customerList" :value="item.customer_id" :key="index">{{ item.customer_name }}</Option>
        </Select>
      </FormItem>
      <FormItem>
        <span class="marginLeft40">产品编号：</span>
        <i-input placeholder="请输入" class="iviewIptWidth250" v-model="queryFrom.product_code"></i-input>
      </FormItem>
      <!-- 产品名称 -->
      <FormItem class="marginLeft40">
        <span>产品名称：</span>
        <Select placeholder="请选择" v-model="queryFrom.product_id" clearable filterable class="iviewIptWidth250" :disabled="!queryFrom.customer_id && queryFrom.customer_id != 0" @on-change="productChange">
          <Option v-for="(item, index) in productShowList" :value="item.product_id" :key="index">{{ item.product_name }}</Option>
        </Select>
      </FormItem>
      <!-- 规格型号/SKU -->
      <FormItem class="marginLeft40">
        <span>规格型号/SKU：</span>
        <Select placeholder="请选择" v-model="queryFrom.product_code_id" clearable filterable class="iviewIptWidth250" :disabled="!queryFrom.product_id && queryFrom.product_id != 0">
          <Option v-for="(item, index) in productModelList" :value="item.code_id" :key="index" :label="item.model_name + '-' + item.item_number">
            <span>{{ item.model_name }}</span>
            <span style="float: right; color: #ccc; margin-right: 20px;">{{ item.item_number }}</span>
          </Option>
        </Select>
      </FormItem>
      <!-- 订单状态 -->
      <FormItem class="marginLeft40">
        <span>订单状态：</span>
        <Select placeholder="请选择" v-model="queryFrom.order_status" clearable filterable class="iviewIptWidth250">
          <Option v-for="(item, index) in orderStatus" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <!-- 下单时间 -->
      <FormItem>
        <span>下单时间：</span>
        <DatePicker clearable placeholder="请选择" format="yyyy-MM-dd" :value="queryFrom.order_time_begin" :editable="false" @on-change="changeTime($event, 1)" class="iviewIptWidth250"></DatePicker>
        <span style="padding: 0 10px;">至</span>
        <DatePicker clearable placeholder="请选择" format="yyyy-MM-dd" :value="queryFrom.order_time_end" :options="options" :editable="false" @on-change="changeTime($event, 2)" class="iviewIptWidth250"></DatePicker>
      </FormItem>
      <!-- 按钮 -->
      <FormItem class="po-create-number marginRight0" :label-width="20">
        <span class="pageBtn finger btnSure" @click="query">查询</span>
        <span class="longTextBtn finger btnAdd marginLeft20" @click="exportFile">
          <Spin style="display: inline-block;" v-show="Loading">
            <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          </Spin>
          合并导出
        </span>
        <span class="pageBtn finger btnSure marginLeft20" @click="setupStatus = true">设置</span>
        <span class="pageBtn finger btnSure marginLeft20" @click="printing">打印</span>
      </FormItem>
    </Form>
    <!-- <Table :productList="listColumns" :productData="listData" :total="total" :pages="queryFrom" @change-page="changePage" totalText="条记录">
      <div slot="summary" class="summary" v-if="listData && listData.length > 0">
        总数量：<span class="color389 marginRight20">{{ total_number }}</span>
        合计金额：<span class="color389">¥{{ total_price }}</span>
      </div>
    </Table> -->
    <div class="clearfix tabDiv" ref="tabDiv">
      <Spin fix v-if="tabloading"></Spin>
      <Table :height="tableHeight" :productList="listColumns" :productData="listData" :option_page="option_page" highlight-row border :chaxunFlag="chaxunFlag" :row-class-name="rowClassName"></Table>
    </div>
    <div class="summary" v-if="listData && listData.length > 0">
      总数量：<span class="color389 marginRight20">{{ total_number }}</span> 合计金额：<span class="color389">¥{{ total_price }}</span>
    </div>
    <div class="pages" v-if="listData !== null && listData.length > 0 && total">
      <Page v-if="queryFrom && total <= 60" :total="total" :current="queryFrom.page" @on-change="changePage" class="fl" />
      <Page v-if="queryFrom && total > 60" :total="total" :current="queryFrom.page" @on-change="changePage" show-elevator class="fl" />
      <div class="fr totalFont" v-if="total">共计{{ total }}条记录</div>
    </div>
    <!-- <div style="position: relative; border: 1px solid #e8eaec; height: 500px; border-top: none !important;" class="clearfix noData" v-if="listData !== null && listData.length == 0">
        <img style="margin-top: 100px;" src="@/assets/images/tableNoData.png" />
      </div> -->
    <!-- 动态表头弹窗 -->
    <table-setup v-if="setupStatus" :pageList="titleList" :option_page="option_page" @cancleBtn="setupStatus = false" @sureBrn="sureSetup"></table-setup>
    <Modal v-model="status" title="请选择模版" cancel-text @on-cancel="status = false" width="568">
      <div class="clearfix paddingBot40px">
        <div class="item">
          <span class="itemTitle">模版类型：</span>
          <Select placeholder="请选择" v-model="template_type" filterable class="iviewIptWidth307" @on-change="typeChange">
            <Option v-for="(item, index) in TemplateList" :value="item.typeID" :key="index">{{ item.typeName }}</Option>
          </Select>
        </div>
        <div class="item">
          <span class="itemTitle">模版名称：</span>
          <Select placeholder="请选择" v-model="template_id" filterable class="iviewIptWidth307" :disabled="!template_type">
            <Option v-for="(item, index) in typeList" :value="item.template_id" :key="index">{{ item.template_name }}</Option>
          </Select>
        </div>
        <!-- <div class="item">
          <span class="itemTitle">每页行数：</span>
          <InputNumber  :min="0" :precision="0" v-model="paging" :active-change="false"  class="iviewIptWidth307"></InputNumber>
        </div> -->
      </div>
      <div slot="footer">
        <span class="pageBtn finger btnSure" @click="surePrint">确定</span>
      </div>
    </Modal>
  </div>
</template>

<script>
import Table from '@/components/table'
import TableSetup from '@/components/tableSetup'

export default {
  name: 'salesRecordConsign',
  components: {
    Table,
    TableSetup,
  },
  data() {
    return {
      chaxunFlag: true,
      tabloading: false,
      Loading: false,
      tableHeight: 0,
      TemplateList: [
        { typeName: '采购单', typeID: 1 },
        { typeName: '收货验收单', typeID: 2 },
        { typeName: '入库单', typeID: 3 },
        { typeName: '销售单', typeID: 4 },
        { typeName: '拣货单', typeID: 5 },
        { typeName: '出库单', typeID: 6 },
        { typeName: '采购记录', typeID: 7 },
        { typeName: '收货验收记录', typeID: 8 },
        { typeName: '入库记录', typeID: 9 },
        { typeName: '销售记录', typeID: 10 },
        { typeName: '拣货记录', typeID: 11 },
        { typeName: '出库记录', typeID: 12 },
        { typeName: '调拨单', typeID: 13 },
      ],
      template_id: '',
      template_type: 10,
      typeList: [],
      status: false,
      titleList: [],
      option_page: '07',
      // 动态表头弹窗
      setupStatus: false,
      // 总数量
      total_number: 0,
      // 总金额
      total_price: 0,
      // 总条数
      total: 0,
      options: {},
      // 表格数据
      listData: [],
      // 表格头部标题
      listColumns: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          minWidth: 75,
          maxWidth: 90,
        },
        {
          title: '客户名称',
          key: 'customer_name',
          align: 'center',
          minWidth: 250,
        },
        {
          title: '产品名称',
          key: 'product_name',
          align: 'center',
          minWidth: 250,
        },
        {
          title: '注册证号/备案凭证号',
          key: 'licence_code',
          align: 'center',
          minWidth: 180,
        },
        {
          title: '规格型号',
          key: 'product_model_name',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '货号/SKU',
          key: 'product_item_number',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '供货单价',
          key: 'product_unit_price',
          align: 'center',
          minWidth: 100,
          render: (h, param) => {
            let str = param.row.product_unit_price ? '¥' + param.row.product_unit_price : ''
            return h('span', str)
          },
        },
        {
          title: '数量',
          key: 'product_amount',
          align: 'center',
          minWidth: 80,
        },
        {
          title: '小计',
          key: 'product_total_price',
          align: 'center',
          minWidth: 100,
          render: (h, param) => {
            let str = param.row.product_total_price ? '¥' + param.row.product_total_price : ''
            return h('span', str)
          },
        },
        {
          title: '订单状态',
          key: 'order_status',
          align: 'center',
          minWidth: 80,
        },
        {
          title: '订单时间',
          key: 'order_time',
          align: 'center',
          minWidth: 150,
        },
      ],
      // 订单类型下拉
      orderStatus: [
        { id: '1', name: '待发货' },
        { id: '2', name: '部分发货' },
        { id: '3', name: '待开票' },
        { id: '4', name: '已完成' },
        // {id: '5', name: '待反冲'},
      ],
      // 规格型号下拉
      productModelList: [],
      // 产品下拉
      productShowList: [],
      // 客户下拉
      customerList: [],
      // 查询参数
      queryFrom: {
        product_code: '',
        page: 1,
        rows: 10,
        customer_id: undefined,
        customer_type: '',
        product_id: undefined,
        product_code_id: undefined,
        order_time_begin: '',
        order_time_end: '',
        order_status: '',
      },
      paging: null,
    }
  },
  mounted() {
    this.queryOption()
    this.getCustomerList()
  },
  methods: {
    printing() {
      this.status = true
      this.getTemplate()
    },
    // 获取最近的模板
    getTemplate() {
      // 获取模板名称
      this.$http.get(this.$apiConsign.templateInfo, { template_type: this.template_type }, false).then(res => {
        this.typeList = res.data
      })
      // 获取模板记录
      this.$http.get(this.$apiConsign.recentTemplate, { template_type: this.template_type }, true).then(res => {
        if (res.data) {
          this.template_id = res.data.template_id
        }
      })
    },
    surePrint() {
      let api_info = `${this.$apiConsign.gspSaleProductRecord.url}?`
      console.log(this.queryFrom)
      for (let objName in this.queryFrom) {
        console.log(objName)
        if (this.queryFrom[objName]) {
          api_info = api_info + `${objName}=${this.queryFrom[objName]}&`
        }
      }
      if (!this.template_type) {
        this.$Message.warning('请选择模版类型')
        return
      }
      if (!this.template_id) {
        this.$Message.warning('请选择模版名称')
        return
      }
      this.$http.downFile(this.$apiConsign.templatePrint, { template_id: this.template_id, api_info: api_info, paging: this.paging }, true).then(res => {
        this.status = false
        this.$Message.success('导出成功')
        let blob = new Blob([res.data], { type: 'application/x-xlsx' })
        const aLink = document.createElement('a')
        aLink.href = URL.createObjectURL(blob)
        aLink.download = '销售产品记录.xlsx'
        aLink.click()
      })
    },
    // 发送请求获取 模版名称
    typeChange(e) {
      if (!e) return
      this.$http.get(this.$apiConsign.templateInfo, { template_type: e }, false).then(res => {
        this.typeList = res.data
      })
    },
    sureSetup(val) {
      this.queryOption()
    },
    // 获取表格表头
    queryOption() {
      this.tabloading = true
      this.$http
        .get(this.$apiConsign.systemOptionItem, { option_page: this.option_page })
        .then(res => {
          this.titleList = res.data.enable
          localStorage.setItem('adminTtitleList', JSON.stringify(res.data.list))
          for (let i = 0; i < this.titleList.length; i++) {
            if (this.titleList[i].show) {
              this.titleList[i].key = this.titleList[i].data_col
              this.titleList[i].width = this.titleList[i].column_width
              this.titleList[i].align = 'center'
              this.titleList[i].resizable = true
            }
          }
          this.listColumns = []
          this.listColumns.unshift({
            title: '序号',
            type: 'index',
            align: 'center',
            width: 60,
          })
          this.listColumns = [...this.listColumns, ...this.titleList]
          this.listColumns = JSON.parse(JSON.stringify(this.listColumns))
        })
        .then(() => {
          this.tabloading = false
          // this.queryList()
        })
    },
    // 导出
    exportFile() {
      let data = {
        customer_id: this.queryFrom.customer_id,
        customer_type: this.queryFrom.customer_type,
        product_id: this.queryFrom.product_id,
        product_code_id: this.queryFrom.product_code_id,
        order_time_begin: this.queryFrom.order_time_begin,
        order_time_end: this.queryFrom.order_time_end,
        order_status: this.queryFrom.order_status,
      }
      this.Loading = true
      this.$http.downFile(this.$apiConsign.gspSaleProductRecordExport, this.queryFrom).then(res => {
        this.Loading = false
        let blob = new Blob([res.data], { type: 'application/x-xlsx' })
        const aLink = document.createElement('a')
        aLink.href = URL.createObjectURL(blob)
        aLink.download = '销售产品记录导出表.xlsx'
        aLink.click()
      })
    },
    // 反冲成功的行标红
    rowClassName(row, index) {
      if (row.order_status == '待反冲') return 'redRow'
      return ''
    },
    // 点击查询按钮
    query() {
      this.queryFrom.page = 1
      this.queryList()
    },
    // 分页改变
    changePage(e) {
      this.queryFrom.page = e
      this.queryList()
    },
    // 时间改变
    changeTime(e, num) {
      if (num == 1) {
        let that = this
        this.queryFrom.order_time_begin = e
        // 清空截止日期
        if (e > this.queryFrom.order_time_end) {
          this.queryFrom.order_time_end = ''
        }
        this.options = {
          disabledDate(date) {
            return date && date.valueOf() < new Date(that.queryFrom.order_time_begin) - 86400000
          },
        }
      } else {
        this.queryFrom.order_time_end = e
      }
    },
    // 产品名称改变
    productChange(e) {
      this.productModelList = []
      this.queryFrom.product_code_id = undefined
      if (!e) return
      // 规格型号下拉 and 货号/SKU下拉
      let data = {
        search_type: '1',
        customer_type: this.queryFrom.customer_type,
        product_id: this.queryFrom.product_id,
      }
      if (this.queryFrom.customer_type == '2') {
        data.customer_id = this.queryFrom.customer_id
      }
      this.$http.get(this.$apiConsign.productShow, data).then(res => {
        this.productModelList = res.data
      })
    },
    // 客户名称改变
    customerChange(e) {
      this.productShowList = []
      this.queryFrom.product_id = undefined
      this.queryFrom.customer_type = ''
      // 判断客户类型
      if (e) {
        this.customerList.forEach(item => {
          if (item.customer_id == e.value && item.customer_name == e.label) {
            this.queryFrom.customer_type = item.customer_type
          }
        })
      } else {
        this.queryFrom.customer_type = ''
        return
      }
      // 产品下拉
      let data = {
        search_type: '1',
        customer_type: this.queryFrom.customer_type,
      }
      if (this.queryFrom.customer_type == '2') {
        data.customer_id = this.queryFrom.customer_id
      }
      this.$http.get(this.$apiConsign.productShow, data).then(res => {
        this.productShowList = res.data
      })
    },
    // 客户名称下拉
    getCustomerList() {
      this.$http.get(this.$apiConsign.customerList).then(res => {
        this.customerList = res.data
      })
    },
    // 查询列表数据
    queryList() {
      this.chaxunFlag = false
      let id
      this.tabloading = true
      this.productShowList.forEach(item => {
        if (item.product_id == this.queryFrom.product_id) {
          // 这一步是为了回显选项
          id = this.queryFrom.product_id
          this.queryFrom.product_id = item.product_name
        }
      })
      this.$http.get(this.$apiConsign.gspSaleProductRecord, this.queryFrom, false).then(res => {
        this.listData = res.data
        this.total_number = res.total_number
        this.total_price = res.total_price
        this.total = res.total
        // 处理动态表头页面列表数据
        this.listData = this.$utils.dynamicHeaderList(this, this.listData)
        if (this.listData.length > 0) {
          this.$nextTick(() => {
            this.tableHeight = this.$refs.tabDiv.offsetHeight + ''
          })
        } else {
          this.$nextTick(() => {
            this.tableHeight = '0'
          })
        }
        //回显选项
        this.queryFrom.product_id = id
        this.tabloading = false
      })
    },
    // 详情
    details(row) {
      this.$router.push({
        path: '/detailsPurchaseOrderRecordConsign',
      })
    },
  },
}
</script>

<style scoped lang="less">
.home {
  display: flex;
  flex-direction: column;
  overflow: hidden !important;
}
// 表格
.tabDiv {
  flex: 1;
  overflow-y: auto;
  height: 100%;
  .totalFont {
    font-size: 14px;
  }
  .pages {
    margin-top: 10px;
    overflow: hidden;
    line-height: 32px;
  }
}
.paddingBot40px {
  padding-bottom: 40px;
}
.item {
  display: flex;
  align-items: center;
  justify-items: center;
  margin-bottom: 20px;
  .itemTitle {
    width: 100px;
    color: #000;
    text-align: justify;
    height: 32px;
    line-height: 32px;
  }
  .itemTitle::after {
    content: '';
    display: inline-block;
    padding-left: 100%;
  }
}
</style>
